import { render, staticRenderFns } from "./SimpleEmailComposer.vue?vue&type=template&id=127127ea&scoped=true"
import script from "./SimpleEmailComposer.vue?vue&type=script&lang=js"
export * from "./SimpleEmailComposer.vue?vue&type=script&lang=js"
import style0 from "./SimpleEmailComposer.vue?vue&type=style&index=0&id=127127ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127127ea",
  null
  
)

export default component.exports